import { useUBL } from '@common/log-manager';
import { useCatalogProductIdParams, usePdpBaseInfo, usePdpConfig } from '@domains/pdp-common';

export const useMetaStylePdpLinkService = () => {
  const sendUBL = useUBL();
  const { isZigzagApp } = usePdpConfig();
  const param = useCatalogProductIdParams();
  const {
    product,
    product: { external_product_url, is_brand, browsing_type },
  } = usePdpBaseInfo(param);
  const shop_department = is_brand ? '브랜드몰' : '쇼핑몰';
  const onClickMetaStyle = () => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_id: 'move_to_matched_pdp',
      data: { catalog_product_id: product.id, browsing_type },
    });

    if (!external_product_url) {
      return;
    }

    if (!isZigzagApp) {
      window.open(external_product_url);
      return;
    }

    // MEMO: AOS 14버전에서 external_product_url https:// 프로토콜 파싱 과정에서 : 누락 이슈가 발생하여 처리 방식 변경
    window.location.href = `zigzag://open/browser?url=${external_product_url}`;
  };

  return { isHide: !external_product_url, shop_department, onClickMetaStyle };
};
